import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How do I hire ReactJS developers?",
    answer: `<p>When planning to hire ReactJS developers, consider the following steps:</p>
    <ul>
    <li>Receive a selection of developer profiles tailored to your requirements.</li>
    <li>Screen and identify the top candidates from a carefully vetted list.</li>
    <li>Conduct interviews and shortlist the best fit for your project.</li>
    <li>Follow TekRevol’s onboarding process to bring your chosen developers on board and begin your project.</li>
    </ul>`,
  },
  {
    question:
      "What are the modes of communication through which we can get in touch with remote react developers?",
    answer: `<p>TekRevol ensures 100% transparent communication throughout the Software Development Life Cycle (SDLC) by utilizing various communication channels. These include Teams, Skype, Zoom, Confluence, Jira, Slack, and Email.</p>`,
  },
  {
    question:
      "Can I hire a full-stack ReactJS developer for the hourly or project-based tasks?",
    answer: `<p>Yes, you can hire a full-stack ReactJS developer for either hourly or project-based tasks. TekRevol provides flexible hiring models, allowing you to choose between hourly or project-based engagements based on your specific needs.</p>`,
  },
  {
    question: "Why hire ReactJS developers from TekRevol?",
    answer: `<p>Hiring ReactJS developers from TekRevol offers a wide range of benefits, from exceptional technical skills to the ability to handle complex application development. Our team comprises over 25 seasoned ReactJS programmers proficient in various technologies to ensure your project's success.</p>
    <p>Here are some more advantages of hiring our React developers:</p>
    <ul>
    <li>Certified ReactJS Developers</li>
     <li>24/7 Technical Support</li>
      <li>Strict NDA Compliance</li>
      <li>Source Code Ownership</li>
       <li>No-Obligation Project Quotes</li> 
      <li>Efficient Project Management</li>   
      <li>Flexible Engagement Models</li>  
      <li>World-Class Development Expertise</li> 
    </ul>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Hire ReactJS Developers FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
